import EnvironmentConfigsService from 'commons-configs/services/EnvironmentConfigsService.js';
import ConfigsModel from 'commons-configs/models/ConfigsModel.js';
import ConfigsContainer from 'commons-configs/components/containers/ConfigsContainer.js';

export { EnvironmentConfigsService, ConfigsModel, ConfigsContainer };

export default {
    EnvironmentConfigsService,
    ConfigsModel,
    ConfigsContainer,
};
